require("../../scss/indice.scss");
import ScrollReveal from 'scrollreveal';
import Chart from 'chart.js/dist/Chart.js';
import Accordeon from "accordion-js";

var indice = function(){

    var getData, from, to, elchart, getMonthName, parseData, showData;
    var months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

    var filters = [];
    filters["indice"] = false;
    filters["variacion"] = false;
    filters["dolares"] = true;
    filters["pesos"] = true;

    var filterColors = [];
    filterColors["indice"] = "#D9E021";
    filterColors["variacion"] = "#808080";
    filterColors["dolares"] = "#999999";
    filterColors["pesos"] = "#7373A5";

    var dataFull;

	constructor = function(){
		Chart.defaults.global.defaultFontFamily = "'Roboto Condensed', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
        var baseConfig = {
            type: 'line',
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [
                    
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Mes'
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Pesos'
                        }
                    }]
                },
                tooltips:{
                    backgroundColor: 'rgba(0, 0, 0, 1)',
                    titleFontColor: "rgba(204, 204, 204, 1)",
                    borderColor: 'rgba(0,0,0,1)',
                    intersect: false,
                    position: 'nearest',
                    mode: 'index',
                    caretSize: 9,
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true
                    }
                  }]
                }
            }
        };

        //acordeon
        var accordion = new Accordion('#anteriores', {
            elementClass : "acitem"
        });

        var elem = document.getElementById("indice");
        elchart = new Chart(elem, baseConfig);

        $("#from").change(function(){
            getData();
        });
        $("#to").change(function(){
            getData();
        });
        getData();

        //events
        $(".btnsGrafico a.btn").click(function(){
            var filter = $(this).data("filter");
            filters[filter] = !filters[filter];
            showData();
            return false;
        })
        

		//keep the hash updated
		$(window).resize();
	}

    getMonthName = function(month){
        return months[month-1];
    }

    getData = function(){
        if($("#from").val() == "" || $("#to").val() == "") return;
        var data = {
            from: $("#from").val(),
            to: $("#to").val()
        }
        $.get(
            "/indice-esarq-data",
            data,
            function(response){
                dataFull = response;
                showData();
            }
        ).fail(function() {
            alert("Se produjo un error inesperado. Inténtelo más tarde.")
        });
    }

    showData = function(){
        var chartData = {
            labels:[],
            datasets: []
        }

        var multiYear = false;
        var tlabel = $("#to").val();
        if($("#from").val() != tlabel){
            tlabel = $("#from").val() + " - "+tlabel;
            multiYear = true;
        }

        //parse labels
        for (var i = dataFull.length - 1; i >= 0; i--) {
            chartData.labels.push(getMonthName(dataFull[i].mesnombre)+" "+dataFull[i].mesanio);
        }

        //parse recursive
        for(var filter in filters){
            if(filters[filter]){
                $(".btn-"+filter).addClass("active");
                var tmpDataset = {
                    label: filter.toUpperCase(),
                    data: [
                       
                    ],
                    backgroundColor: filterColors[filter],
                    borderColor: filterColors[filter],
                    fill: false,
                }
                for (var i = dataFull.length - 1; i >= 0; i--) {
                    tmpDataset.data.push(dataFull[i][filter]);
                }
                chartData.datasets.push(tmpDataset)
            }else{
                $(".btn-"+filter).removeClass("active");
            }
        }
        elchart.config.data = chartData;
        elchart.update();
    }

	resizeWin = function(viewportSize){

	}

	$(document).ready(constructor);

	return {
		resize: resizeWin
	}
}

indice();